import React from "react";
import PropTypes from "prop-types";
import { Form } from "~components";

const FormFormspark = ({ _css, children, formId }) => {
  const onSubmit = async ({ data, reset }) => {
    if (!window || window.location.href.includes(`localhost:8000`)) {
      reset();
      return;
    }

    try {
      await fetch(`https://submit-form.com/${formId}`, {
        method: `POST`,
        headers: {
          "Content-Type": `application/json`,
          Accept: `application/json`
        },
        body: JSON.stringify(data)
      });
    } catch (err) {
      console.error(`Form submission failed:`, err);
    }

    reset();
  };

  return (
    <Form _css={_css} onSubmit={onSubmit}>
      {children}
    </Form>
  );
};

FormFormspark.defaultProps = {
  _css: {}
};

FormFormspark.propTypes = {
  _css: PropTypes.shape({}),
  children: PropTypes.node.isRequired
};

export default FormFormspark;
